module.exports = __webpack_public_path__ + "static/media/over50_premium_contract12.9f5f404f.webp";